import type { IconName } from '../components/Icon';
import { EOrganizationFeature } from '../types/enum';
import { sidebarStrings } from './strings';
import { routes } from './routes';

export type NavItem = {
  key: string;
  label: string;
  icon: IconName;
  to: string;
  requiresAdmin?: boolean;
  requiresInternalPlan?: boolean;
  requiresFeature?: EOrganizationFeature;
  /** 組織スコープ（/o/:orgId 配下）の画面なら true */
  orgScoped?: boolean;
};

export const navItems: NavItem[] = [
  {
    key: 'line',
    label: sidebarStrings.navLabels.line,
    icon: 'menuLine',
    to: routes.LINE,
    orgScoped: true,
  },
  {
    key: 'users',
    label: sidebarStrings.navLabels.users,
    icon: 'menuUsers',
    to: routes.USERS,
    orgScoped: true,
  },
  {
    key: 'tag',
    label: sidebarStrings.navLabels.tag,
    icon: 'menuUsers',
    to: routes.TAG_MANAGEMENT,
    requiresFeature: EOrganizationFeature.TAG_MANAGEMENT,
    orgScoped: true,
  },
  {
    key: 'survey',
    label: 'アンケート',
    icon: 'calendar',
    to: routes.SURVEY_MANAGEMENT,
    requiresFeature: EOrganizationFeature.SURVEY,
    orgScoped: true,
  },
  {
    key: 'chat',
    label: sidebarStrings.navLabels.chat,
    icon: 'menuChat',
    to: routes.CHAT,
    orgScoped: true,
  },
  {
    key: 'sendMessageForAll',
    label: sidebarStrings.navLabels.sendMessageForAll,
    icon: 'sendMessage',
    to: routes.SEND_MESSAGE_FOR_ALL,
    orgScoped: true,
  },
  {
    key: 'scenarios',
    label: 'ステップ配信',
    icon: 'sendMessage',
    to: routes.SCENARIOS,
    requiresFeature: EOrganizationFeature.STEP_DELIVERY,
    orgScoped: true,
  },
  {
    key: 'banStatus',
    label: sidebarStrings.navLabels.banStatus,
    icon: 'menuLine',
    to: routes.BAN_STATUS,
    requiresAdmin: true,
  },
  {
    key: 'organizationManagement',
    label: sidebarStrings.navLabels.organizationManagement,
    icon: 'menuUsers',
    to: routes.ORGANIZATION_MANAGEMENT,
    requiresAdmin: true,
  },
  {
    key: 'accountManagement',
    label: sidebarStrings.navLabels.accountManagement,
    icon: 'menuUsers',
    to: routes.ACCOUNT_MANAGEMENT,
    requiresAdmin: true,
  },
  {
    key: 'termsManagement',
    label: sidebarStrings.navLabels.termsManagement,
    icon: 'menuSettings',
    to: routes.TERMS_MANAGEMENT,
    requiresAdmin: true,
  },
  {
    key: 'oaCreation',
    label: sidebarStrings.navLabels.oaCreation,
    icon: 'menuLine',
    to: routes.OA_CREATION,
    requiresAdmin: true,
    requiresInternalPlan: true,
  },
  {
    key: 'summaryManagement',
    label: sidebarStrings.navLabels.summaryManagement,
    icon: 'calendar',
    to: routes.SUMMARY_MANAGEMENT,
    orgScoped: true,
  },
  {
    key: 'friendAnalytics',
    label: sidebarStrings.navLabels.friendAnalytics,
    icon: 'menuUsers',
    to: routes.FRIEND_ANALYTICS,
    orgScoped: true,
  },
  {
    key: 'adCode',
    label: sidebarStrings.navLabels.adCode,
    icon: 'megaphone',
    to: routes.AD_CODES,
    orgScoped: true,
  },
  {
    key: 'inquiryChat',
    label: sidebarStrings.navLabels.inquiryChat,
    icon: 'menuChat',
    to: routes.INQUIRY_CHAT,
    orgScoped: true,
  },
];
